import React, { Component } from 'react'
import Field from 'components/controls/field'
import 'less/collapsible-timeSlots.less'
import moment from 'moment'

class CollapsibleTimeSlots extends Component {
  constructor (props) {
    super(props)
    this.state = {
      show: false,
    }
  }

  toggleCollapse = () => this.setState({ show: !this.state.show })

  render () {
    const {
      day,
      label,
      onChangeHandler,
      isChecked,
      t,
      updateSlot,
      formatDate,
      sortTimeSlots,
      availabilityByDay,
      selectedTimeSlot,
      setSelectedTimeSlot,
      setSelectedTimeSlotDetails
    } = this.props

    return (
      <div className="time-slot-list-container">
        <div className="time-slot-list-controls" onClick={this.toggleCollapse}>
          <div className="time-slot-list-info">
            <h1 className="day-of-the-month">{day.slice(-2)}</h1>
            <div className="date-info">
              <span>{formatDate(day, 'MMMM yyyy')}</span>
              <div className="date-subtext">
                <span className="day-of-the-week">{formatDate(day, 'dddd')}</span>
                <span className="num-slots">{availabilityByDay[day].length} {t('open.slots').toUpperCase()}</span>
              </div>
            </div>
          </div>
          {this.state.show ? <i className="im-ss-navigatedown" /> : <i className="im-ss-navigateright" />}
        </div>

        {this.state.show? <div className={`collapse ${this.state.show ? 'show' : ''}`} id={day}>
          {sortTimeSlots(availabilityByDay[day]).map((slot, i) =>
            <Field
              type="radio"
              label={label(slot.startTime, slot.endTime, t, formatDate)}
              checked={slot.id === selectedTimeSlot}
              onClick={e => {setSelectedTimeSlot(slot.id);setSelectedTimeSlotDetails(slot)}}
              key={i}
            />
          )}
        </div>: <div></div>}
      </div>
    )
  }
}

export default CollapsibleTimeSlots
